/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Low_Quality_BadgeInputs */



/**
* | output |
* | --- |
* | "Low quality" |
*
* @param {Voice_Manager_Low_Quality_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_low_quality_badge = /** @type {((inputs?: Voice_Manager_Low_Quality_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Low_Quality_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("de mauvaise qualité")
	if (locale === "de") return /** @type {LocalizedString} */ ("Niedrige Qualität")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bassa qualità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Низкое качество")
	if (locale === "es") return /** @type {LocalizedString} */ ("Baja calidad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("低质量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("低品質")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खराब क्वालिटी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixa qualidade")
	return /** @type {LocalizedString} */ ("Low quality")
});